import React from 'react';
import './live-pop-up.css';
import { generateClient } from 'aws-amplify/api';
import { useParams } from 'react-router';
import * as config from '../../aws-exports';
import { updateMeetingStatus } from '../../graphql/mutations';
import UpdateMeetingStatus from '../../services/event/update-meeting-status';
import { toast } from 'react-toastify';
const client = generateClient(config);

interface SdkData {
  meetingNumber: string;
  password: string;
  userName: string;
  userEmail: string;
  signature: string;
  tk?: string;
}

interface LivePopupProps {
  sdkData: SdkData;
  setIsPopupVisible: (isVisible: boolean) => void;
  onClose: () => void;
  mStatus: boolean;
}

const LivePopup: React.FC<LivePopupProps> = ({ sdkData, setIsPopupVisible, onClose, mStatus }) => {
  const { eventId } = useParams<{ eventId: string }>();
  const webinarStatus = mStatus ? false : true
  const handleYesClick = async () => {
    try {
      const numericEventId = Number(eventId);
      // Initialize the payload with isMeetingLive
      const payload: any = {
        isMeetingLive: webinarStatus, // Sending isMeetingLive in the payload
      };

      // Conditionally add isMeetingEnd if isMeetingLive is false
      if (!webinarStatus) {
        payload.isMeetingEnd = true;
      } else {
        payload.isMeetingEnd = false;
      }

      const response = await UpdateMeetingStatus(payload, numericEventId);

      if (response && response.status === 200) {
        const variables = {
          eventid: eventId as string,
          meetingstatusflag: webinarStatus,
        };

        try {
          await client.graphql({
            query: updateMeetingStatus,
            variables: variables,
          });
          // Close the popup after successful update
          setIsPopupVisible(false);
          onClose();
        } catch (error) {
          console.error('Error updating meeting status:', error);
          toast.error('Error updating meeting status');
        }

      } else if (response && response.status === 404) {
        toast.error(response.data.message);
      } else {
        toast.error('API call failed');
      }
    } catch (error) {
      if (error instanceof Error) {
        toast.error(`Error: ${error.message}`);
      } else {
        toast.error('An unexpected error occurred');
      }
    }
  };

  const handleCloseClick = () => {
    setIsPopupVisible(false);
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="text-wrapper">{webinarStatus ? "Go Live" : "End webinar"}</div>
        <div className="option-wrapper">
          <button className="option-btn" onClick={handleYesClick}>
            Yes
          </button>
          <button className="option-btn" onClick={handleCloseClick}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LivePopup;
